<app-complex-modal-template
    [canConfirm]="!!shapingProjectService.projectForm?.valid"
    [title]="data.title | transloco"
    (onClickEvent)="onClickEvent($event)">
    @if (shapingProjectService.projectForm) {
        <form [formGroup]="shapingProjectService.projectForm">
            <div class="flex flex-col w-full">
                <div class="flex flex-row gap-4">
                    <div class="flex flex-col">
                        <span class="flex py-4 text-on-surface">{{ 'color' | transloco }}</span>
                        <app-color-dropdown [colorControl]="shapingProjectService.projectForm.controls.color" />
                    </div>

                    <div class="flex flex-col w-1/2">
                        <span class="flex py-4 text-on-surface">{{ 'projectName' | transloco }}</span>
                        <mat-form-field
                            appearance="outline"
                            class="w-full"
                            floatLabel="always"
                            subscriptSizing="dynamic">
                            <mat-label>{{ 'name' | transloco }}</mat-label>
                            <input
                                #nameInput
                                formControlName="name"
                                matInput
                                type="text"
                                [placeholder]="'defineProjectName' | transloco" />

                            @if (shapingProjectService.projectForm.controls.name.dirty) {
                                <button
                                    mat-icon-button
                                    matSuffix
                                    type="button"
                                    [attr.aria-label]="'clear' | transloco"
                                    (click)="shapingProjectService.projectForm.controls.name.reset()">
                                    <fa-icon [icon]="['fas', 'close']" />
                                </button>
                            }

                            @for (
                                error of shapingProjectService.projectForm.controls.name.errors | keyvalue;
                                track error
                            ) {
                                <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>

                @if (projections()) {
                    <span class="flex py-4 text-on-surface">{{ 'mapProjection' | transloco }}</span>
                    <div class="flex flex-row gap-4">
                        <mat-form-field
                            appearance="outline"
                            class="place-self-center">
                            <mat-select [formControl]="shapingProjectService.projectForm.controls.projection">
                                @for (projection of projections(); track projection) {
                                    <mat-option [value]="projection.value">
                                        {{ projection.text }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                }
            </div>
        </form>
    } @else {
        <app-loading />
    }
    <ng-container modalActions>
        @if (shapingProjectService.projectForm) {
            <app-button
                [icon]="['fas', 'draw-square']"
                [label]="
                    (shapingProjectService.projectForm.controls.bbox.value ? 'updateProjectArea' : 'defineProjectArea')
                        | transloco
                "
                [type]="ButtonType.SECONDARY"
                (onClick)="setProjectBbox()" />
        }
    </ng-container>
</app-complex-modal-template>
